__turbopack_context__.v({
  "badge": "_ic8FW_badge",
  "buyNow": "_ic8FW_buyNow",
  "close": "_ic8FW_close",
  "description": "_ic8FW_description",
  "dialog": "_ic8FW_dialog",
  "finePrint": "_ic8FW_finePrint",
  "header": "_ic8FW_header",
  "overlay": "_ic8FW_overlay",
  "retailerLink": "_ic8FW_retailerLink",
  "retailerLogo": "_ic8FW_retailerLogo",
  "retailerName": "_ic8FW_retailerName",
  "retailers": "_ic8FW_retailers",
  "title": "_ic8FW_title",
});
